export function getCookieFromDocument(document: Document, name: string): string | null {
  const cookiesAvailable = document.readyState !== 'loading';
  if (!cookiesAvailable) {
    throw new Error('Document is not ready, cannot access cookies');
  }
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((cookie) => cookie.startsWith(name + '='));
  return cookie ? cookie.split('=').slice(1).join('=') : null;
}
